import { DROPDOWN_API_URI_FORM_TEST, DROPDOWN_NAME } from "../../constants/dropdownConstants";
import { getApiAxios, postApiAxios } from "../../utils/apiClient";
import appConfig from "../../constants/config";
import { createDropdownOption , bindCategoryDDL, createDropdownCurrencyOption} from "./dropdownUtils";
import { createSODropdownOption } from "../../pages/ClaimItems/services/serviceOrder";
import { BindDDLsPDEntitlementLocation, BindDDLsPDEntitlementPercentage } from "../../components/FormInputComponents/PerDiemInputs";
import { isNullOrEmpty } from "../../utils/formValidation";
import { DropdownItem } from "../../components/ConfigPage/models/Config.interface";
import { translate } from "../../utils/translateUtils";
import { getObjectAttachment, getObjectCreator } from "../../utils/localStorage/localStorage";

export interface CategoryDetailTypeCatalog {
    available: boolean;
    categoryOptions: DropdownItem[];
    detailTypeOptionsByCategory: Record<string, DropdownItem[]>;
}

const createCatalogDropdownOptions = (items: any[]): DropdownItem[] => {
    const optionsById = new Map<string, DropdownItem>();

    (Array.isArray(items) ? items : []).forEach((item: any) => {
        if (item?.id === undefined || item?.id === null || item.id === "") {
            return;
        }

        const value = String(item.id);
        if (!optionsById.has(value)) {
            optionsById.set(value, {
                value,
                label: translate(item.text),
            });
        }
    });

    return Array.from(optionsById.values());
};

export const getCategoryDetailTypeCatalog = async (objectRequester: any): Promise<CategoryDetailTypeCatalog> => {
    const response = await postApiAxios(appConfig.connectionString.ws + "/api/GetCategoryDetailTypeCatalog", {
        user_id: objectRequester.personnel_number,
        country_code: objectRequester.country_code,
        company_code: objectRequester.company_code,
        is_cc: 0,
    });

    const categories = Array.isArray(response?.categories) ? response.categories : [];
    const catalogCategories = response?.available === true ? categories : [];

    const detailTypeOptionsByCategory = catalogCategories.reduce(
        (optionsByCategory: Record<string, DropdownItem[]>, category: any) => {
            if (category?.id !== undefined && category?.id !== null && category.id !== "") {
                optionsByCategory[String(category.id)] = createCatalogDropdownOptions(category.detailTypes);
            }
            return optionsByCategory;
        },
        {}
    );

    return {
        available: response?.available === true,
        categoryOptions: createCatalogDropdownOptions(catalogCategories),
        detailTypeOptionsByCategory,
    };
};

export const dropdownMappings: Record<string, (objectRequester: any, query_mode?: string, viewAll?: boolean, objAttr?: any, categoryId?:any, module?:string) => Promise<any>> = {
    [DROPDOWN_NAME.Category]: async (objectRequester, query_mode?, viewAll?, objAttr?, categoryId?, module?) => {
        let empId = "", countryCode = "", companyCode = "", languageCode = "", objAttachment = null;
        //Begin,saber INC - 842985 , if is_cc should not have cash advance , cash refund and cash card
        objAttachment = !isNullOrEmpty(objAttr) ? objAttr : getObjectAttachment();
        let is_cc = 0;

        if((!isNullOrEmpty(module) && module?.toLowerCase() == 'expreport') && (query_mode == "hr" || query_mode == "team" || query_mode == "finance")){
            
            empId = objAttachment.requestor_user_id;
            countryCode = objAttachment.company_code.slice(0, 2);
            companyCode = objAttachment.company_code;
            languageCode = objectRequester.language_code;
        }
        else{
            
            empId = objectRequester.personnel_number;
            countryCode = objectRequester.country_code;
            companyCode = objectRequester.company_code;
            languageCode = objectRequester.language_code;
            is_cc = objAttachment?.iS_CC ?? 0;
        }

        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.Category], {
            'employee_id': empId,
            'country_code': countryCode,
            'company_code': companyCode,
            'language_code': languageCode,
            'is_cc': is_cc
        }); 
        //End, Saber INC - 842985 , if is_cc should not have cash advance , cash refund and cash card
        // localStorage.setItem("objSubCatsInputs", JSON.stringify(response));
        const filteredResponse = bindCategoryDDL(response, true, objectRequester, module);
        localStorage.setItem("objSubCatsInputs", JSON.stringify(filteredResponse));
        return createDropdownOption(filteredResponse);
    },
    [DROPDOWN_NAME.ReceiptCurrency]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.ReceiptCurrency], {
            'country_code': objectRequester.company_code,
            'currency_code': objectRequester.currency_code
        })
        return createDropdownCurrencyOption(response);
    },
    [DROPDOWN_NAME.TravelRefNo]: async (objectRequester, query_mode?, viewAll?, objAttr?) => {
        const normalizedQueryMode = String(query_mode ?? "").toLowerCase().replace(/^\?mode=/, "");
        const attachment = Array.isArray(objAttr) ? objAttr[0] : objAttr;
        const personnelNumber =
            (normalizedQueryMode === "team" || normalizedQueryMode === "finance") &&
            !isNullOrEmpty(attachment?.requestor_user_id)
                ? attachment.requestor_user_id
                : objectRequester.personnel_number;
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.TravelRefNo], {
            'personnel_number': personnelNumber,
        })
        return [response, createDropdownOption(response)];
    },
    [DROPDOWN_NAME.market_of_gift_recipient]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.market_of_gift_recipient], {
        })
        return createDropdownOption(response);
    },
    [DROPDOWN_NAME.ClaimTemplate]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.ClaimTemplate], {
            'employee_id': objectRequester.personnel_number,
        })
        return createDropdownOption(response);
    },
    [DROPDOWN_NAME.TransportType]: async (objectRequester,query_mode,viewAll,objAttr,categoryId) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.TransportType], {
            'company_code': objectRequester.company_code,
               //Begin,Saber SR-835940: Pass parameters to loadTransportType function
            'language_code': objectRequester.uI_LANGUAGE_CODE,
            "subcategory_id": categoryId //categoryId
               //End,Saber SR-835940: Pass parameters to loadTransportType function
        })
        return createDropdownOption(response);
    },
    [DROPDOWN_NAME.Form]: async (objectRequester, query_mode?, viewAll?, objAttr?, categoryId?) => {
        //Begin,Saber,20261013,INC-1050242 - Same request as legacy GetDDLDataAvailableForm: selected category, claim mode and saved form_reference_no (SP excludes forms already used by a claim unless mode is View/Edit)
        const attachment = Array.isArray(objAttr) ? objAttr[0] : objAttr;
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.Form], {
            'requestor_user_id': objectRequester.personnel_number,
            'subcategoryid': categoryId ? categoryId : 2, //SP joins TBL_FORM_CONFIGURATION on this; only 3/6/30/46 are configured
            'mode': query_mode ? query_mode.charAt(0).toUpperCase() + query_mode.slice(1).toLowerCase() : 'New',
            'form_reference_no': attachment?.form_reference_no ?? '',
        })
        //getAvailableForm returns name/value/amount (not id/text), createDropdownOption produced empty options
        return (Array.isArray(response) ? response : [])
            .filter((item: any) => !isNullOrEmpty(item?.value))
            .map((item: any) => ({ ...item, label: item.name }));
        //End,Saber,20261013,INC-1050242
    },
    [DROPDOWN_NAME.ProjectCode]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.ProjectCode], {
            'personnel_number': objectRequester.personnel_number,
            'country_code': objectRequester.country_code,
        })
        return createDropdownOption(response);
    },
    [DROPDOWN_NAME.AccommodationType]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.AccommodationType], {
            'company_code': objectRequester.company_code,
            'language_code': objectRequester.language_code,
        })
        return createDropdownOption(response);
    },
    [DROPDOWN_NAME.Country]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.Country], {
            'company_code': objectRequester.company_code,
        })
        return createDropdownOption(response);
    },
    [DROPDOWN_NAME.Hotel]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.Hotel], {
            'country_code': objectRequester.country_code,
        })
        return createDropdownOption(response);
    },
    [DROPDOWN_NAME.City]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.City], {
            'country_code': objectRequester.country_code,
        })
        return createDropdownOption(response);
    },
    [DROPDOWN_NAME.DepartureCountry]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.DepartureCountry], {
            'company_code': objectRequester.company_code,
        })
        return createDropdownOption(response);
    },
    [DROPDOWN_NAME.ArrivalCountry]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.ArrivalCountry], {
            'company_code': objectRequester.company_code,
        })
        return createDropdownOption(response);
    },
    [DROPDOWN_NAME.AddDepartureCountry]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.AddDepartureCountry], {
            'company_code': objectRequester.company_code,
        })
        return createDropdownOption(response);
    },
    [DROPDOWN_NAME.AddArrivalCountry]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.AddArrivalCountry], {
            'company_code': objectRequester.company_code,
        })
        return createDropdownOption(response);
    },

    [DROPDOWN_NAME.DepartureCity]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.DepartureCity], {
            'country_code': objectRequester.country_code,
        })
        return createDropdownOption(response);
    },
    [DROPDOWN_NAME.ArrivalCity]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.ArrivalCity], {
            'country_code': objectRequester.country_code,
        })
        return createDropdownOption(response);
    },
    [DROPDOWN_NAME.AddDepartureCity]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.AddDepartureCity], {
            'country_code': objectRequester.country_code,
        })
        return createDropdownOption(response);
    },
    [DROPDOWN_NAME.AddArrivalCity]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.AddArrivalCity], {
            'country_code': objectRequester.country_code,
        })
        return createDropdownOption(response);
    },

    [DROPDOWN_NAME.Airline]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.Airline], {
            'country_code': objectRequester.country_code,
        })
        return createDropdownOption(response);
    },
    [DROPDOWN_NAME.AddAirline]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.AddAirline], {
            'country_code': objectRequester.country_code,
        })
        return createDropdownOption(response);
    },

    [DROPDOWN_NAME.AddFlightLeg]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.AddFlightLeg], {
            'country_code': objectRequester.country_code,
        })
        return createDropdownOption(response);
    },

    [DROPDOWN_NAME.GiftCountry]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.GiftCountry], {
            'company_code': objectRequester.company_code,
        })
        return createDropdownOption(response);
    },
    [DROPDOWN_NAME.PhoneType]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.PhoneType], {
            'company_code': objectRequester.company_code,
        })
        return createDropdownOption(response);
    },
    [DROPDOWN_NAME.MedicalType]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.MedicalType], {
            'country_code': objectRequester.country_code,
            'language_code': objectRequester.language_code,
        })
        return createDropdownOption(response);
    },
    [DROPDOWN_NAME.CostCenter]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.CostCenter], {
            'company_code': objectRequester.company_code,
            'employee_id': objectRequester.personnel_number,
        })
        return createDropdownOption(response);
    },
    [DROPDOWN_NAME.APEvent]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.APEvent], {
            'country_code': objectRequester.country_code,
        })
        return createDropdownOption(response);
    },
    [DROPDOWN_NAME.APCostElement]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.APCostElement], {
            'country_code': objectRequester.country_code,
            'company_code': objectRequester.company_code,
        })
        return createDropdownOption(response);
    },
    [DROPDOWN_NAME.APVendorCode]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.APVendorCode], {
            'country_code': objectRequester.country_code,
            'company_code': objectRequester.company_code,
        })
        return createDropdownOption(response);
    },
    [DROPDOWN_NAME.PDEntitlementLocation]: async (objectRequester, query_mode, viewAll, objAttr, categoryId) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.PDEntitlementLocation], {
            'country_code': objectRequester.country_code,
            'strRequestor': objectRequester.personnel_number,
            'company_code': objectRequester.company_code,
            'viewAll': viewAll, // finance
            'subcategory_id':categoryId,
            'mode': query_mode,
        })
        return [BindDDLsPDEntitlementLocation({ dataList: response, objAttr: objAttr }), createDropdownOption(response)];
    },
    [DROPDOWN_NAME.PDEntitlementPercentage]: async (objectRequester, mode, viewAll, objAttr) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.PDEntitlementPercentage], {
            'country_code': objectRequester.country_code,
            'company_code': objectRequester.company_code,

        })

        return [BindDDLsPDEntitlementPercentage({ dataList: response, objAttr: objAttr }), createDropdownOption(response)];
    },
    [DROPDOWN_NAME.CashAdvanceType]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.CashAdvanceType], {
            'country_code': objectRequester.country_code,
            'language_code': objectRequester.language_code,
        })
        return createDropdownOption(response);
    },
    [DROPDOWN_NAME.VATBusinessPlace]: async (objectRequester, query_mode) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.VATBusinessPlace], {
            'personnel_number': objectRequester.personnel_number,
            'form_mode': query_mode,
        })
        return createDropdownOption(response);
    },
    [DROPDOWN_NAME.CCStatement]: async (objectRequester, query_mode, viewAll, objAttr, categoryId) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.CCStatement], {
            'requestor_code': (query_mode == "team" || query_mode == "finance") ? objAttr.requestor_user_id : objectRequester.personnel_number,
            'txn_no': !isNullOrEmpty(objAttr.txn_no) ? objAttr.txn_no : "",
        })
        return response.filter((item: any) => item.id !== "" && item.id !== null).map((item: any) => ({
            value: item.id,
            label: translate(item.text),
            ...item,
        }));
    },
    [DROPDOWN_NAME.ServiceOrder]: async (objectRequester, query_mode, viewAll, objAttr, categoryId) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.ServiceOrder], {
            "company_code": objectRequester.company_code,
            "subcategory_id": categoryId,
            "strDeviceInd": 'w'
        })
        return createSODropdownOption(response);
    },
    [DROPDOWN_NAME.TripType]: async (objectRequester) => {
        const objCreator = !isNullOrEmpty(localStorage.getItem("objCreator")) ? JSON.parse(localStorage.getItem("objCreator")!) : null;
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.TripType], {
            "language_code": !isNullOrEmpty(objCreator) ? objCreator.uI_LANGUAGE_CODE : null,
        })
        return createDropdownOption(response);
    },
    [DROPDOWN_NAME.WellnessType]: async (objectRequester) => {
        const objCreator = !isNullOrEmpty(localStorage.getItem("objCreator")) ? JSON.parse(localStorage.getItem("objCreator")!) : null;
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.WellnessType], {
            "company_code": objectRequester.company_code,
            "language_code": !isNullOrEmpty(objCreator) ? objCreator.uI_LANGUAGE_CODE : null,
        })
        return createDropdownOption(response);
    },
    //Begin, Saber,20251016, fixes for Country Area not welln   essType
    [DROPDOWN_NAME.CountryArea]: async (objectRequester, query_mode, viewAll) => {
        const objCreator = !isNullOrEmpty(localStorage.getItem("objCreator")) ? JSON.parse(localStorage.getItem("objCreator")!) : null;
        //const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.WellnessType], {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.CountryArea], {
            "country_code": objectRequester.country_code,
            "company_code": viewAll == true ? '' : objectRequester.company_code
        })
        return createDropdownOption(response);
    },  //End, Saber,20251016, fixes for Country Area not wellnessType
    //Begin, saber INC- 835898, fixes for Other Detail Type with additional Parameter
    [DROPDOWN_NAME.OtherDetailType]: async (objectRequester, query_mode, viewAll, objAttr,categoryId) => {
        const objCreator = !isNullOrEmpty(localStorage.getItem("objCreator")) ? JSON.parse(localStorage.getItem("objCreator")!) : null;
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.OtherDetailType], {
           "company_code": objectRequester.company_code,
            "subcategory_id": categoryId,
            "language_code": objCreator.uI_LANGUAGE_CODE
             
        })
        return createDropdownOption(response);
    }, 
    //End, saber INC- 835898, fixes for Other Detail Type with additional Parameter
    [DROPDOWN_NAME.DetailType]: async (objectRequester, query_mode, viewAll, objAttr, categoryId) => {
        let objCreator = getObjectCreator();
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.DetailType], {
            "company_code": objectRequester.company_code,
            "subcategory_id": categoryId,
            "language_code": objCreator.uI_LANGUAGE_CODE
        })
        return createDropdownOption(response);
    },
    [DROPDOWN_NAME.Region]: async (objectRequester, query_mode, viewAll, objAttr, categoryId) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.Region], {
            "companycode": objectRequester.company_code,
            "subgroup": objectRequester.ee_subgroup_id,
            "globalbucode": objectRequester.prism_global_bu_code,
            "subcategory_id": categoryId
        })
        const dropdownItems: DropdownItem[] = response.filter((item: any) => item.regioN_ID !== "" && item.regioN_ID !== null).map((item: any) => {
            return {
                value: item.rate,
                label: `${item.text}`,
            };
        });
        return Array.from(new Set(dropdownItems.map(item => JSON.stringify(item))))
            .map(str => JSON.parse(str) as DropdownItem);
    },
    [DROPDOWN_NAME.ExpenseNatureType]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.ExpenseNatureType], {
            "company_code": objectRequester.company_code,
        })
        const dropdownItems: DropdownItem[] = response.filter((item: any) => item.id !== "" && item.id !== null).map((item: any) => {
            return {
                id: item.id,
                label: translate(item.text),
                value: item.value,
            };
        });
        return Array.from(new Set(dropdownItems.map(item => JSON.stringify(item))))
            .map(str => JSON.parse(str) as DropdownItem);
    },
    [DROPDOWN_NAME.WBSProjectCode]: async (objectRequester) => {
        const objAttachment = !isNullOrEmpty(localStorage.getItem("objAttachment")) ? JSON.parse(localStorage.getItem("objAttachment")!) : null;
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.WBSProjectCode], {
            "company_code": (window.location.search == "?mode=team" || window.location.search == "?mode=team") ? objAttachment.company_code : objectRequester.company_code,
        })
        const objProjectCodeList = response.sort((a:any, b:any) => {
            return a.text < b.text ? -1 : a.text > b.text ? 1 : 0;
        });

        const dropdownItems: DropdownItem[] = objProjectCodeList.filter((item: any) => item.id !== "" && item.id !== null).map((item: any) => {
            return {
                value: item.wbs_code,
                label: translate(item.text),
            };
        });
        return Array.from(new Set(dropdownItems.map(item => JSON.stringify(item))))
            .map(str => JSON.parse(str) as DropdownItem);
    },
    [DROPDOWN_NAME.CompanyAndBU]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.CompanyAndBU], {
            'requestor_user_id': objectRequester.personnel_number,
        })
        return response;
    },
    [DROPDOWN_NAME.VendorCode]: async (objectRequester, query_mode, viewAll, objAttr) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.VendorCode], {
            "country_code": objectRequester.country_code, 
            "company_code": objectRequester.company_code, 
            "search_text": objAttr
        })
        const objVendorCodeList = response.sort((a:any, b:any) => {
            return a.text < b.text ? -1 : a.text > b.text ? 1 : 0;
        });

        const dropdownItems: DropdownItem[] = objVendorCodeList.filter((item: any) => item.id !== "" && item.id !== null).map((item: any) => {
            return {
                value: item.id,
                label: translate(item.text),
            };
        });
        return Array.from(new Set(dropdownItems.map(item => JSON.stringify(item))))
            .map(str => JSON.parse(str) as DropdownItem);
    },
    [DROPDOWN_NAME.EmployeeSelect]: async (objectRequester) => {
        const response = await getApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.EmployeeSelect] + `?countryCode=${objectRequester.country_code}`, {
        })

        const dropdownItems: DropdownItem[] = response.filter((item: any) => item.id !== "" && item.id !== null).map((item: any) => {
            return {
                value: item.id,
                label: `${item.firstName} ${item.lastName}`,
                firstName: item.firstName,
                lastName: item.lastName
            };
        });
        return Array.from(new Set(dropdownItems.map(item => JSON.stringify(item))))
            .map(str => JSON.parse(str) as DropdownItem);
    },
    // Hazel Amendments 20260113 #CHN-19146 - MM new category - Other oerating expense type 
    [DROPDOWN_NAME.OtherOperatingExpenseType]: async (objectRequester) => {
        const response = await postApiAxios(appConfig.connectionString.ws + DROPDOWN_API_URI_FORM_TEST[DROPDOWN_NAME.OtherOperatingExpenseType], {
            'company_code': objectRequester.company_code,
        })
        return createDropdownOption(response);
    },
};